<template>
  <div
    class="upload-list-box dataupload dialog-primary"
    v-show="visible">
    <div class="header dialog-header">
      <div class="title">上传列表</div>
      <div class="close-btn">
        <span
          class="icon"
          @click="closeDialog">
          <i class="el-icon-close"></i>
        </span>
      </div>
    </div>
    <div class="common-table-box dialog-content">
      <el-table
        class="publish-small-table publish-table"
        highlight-selection-row
        height="100%"
        size="mini"
        :data="fileUploadList"
        v-loading="tableLoading">
        <el-table-column
          label="序号"
          type="index"
          width="75"></el-table-column>
        <el-table-column
          label="文件名称"
          width="220">
          <template v-slot="{ row }">
            <span
              class="text-overflow"
              :title="row.fileName">
              {{ row.fileName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="文件大小"
          width="100">
          <template v-slot="{ row }">
            <span>
              {{
                `${formatFileSize(row.length).fileSize}${
                  formatFileSize(row.length).unit
                }`
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="上传进度"
          width="240">
          <template v-slot="{ row }">
            <div v-if="row.status === -1 || row.status === -2">
              <span class="wating-text">
                <i class="el-icon-time icon"></i>
                等待上传
              </span>
            </div>
            <div v-else-if="row.status === -3">
              <span class="wating-text">
                <i class="el-icon-time icon"></i>
                等待更新
              </span>
            </div>
            <ProgressBar
              v-else
              :fileInfo="row"
              :uploadControl="uploadControl" />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center">
          <template v-slot="{ row }">
            <el-button
              type="text"
              :disabled="row.status === 1"
              @click="deleteFileById(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar.vue'

import { Store } from '@/utils/store'
import { formatFileSize } from '@/utils/generalMethods'

import { importUploadListService, deleteFileService } from '@/service/interface'

export default {
  data() {
    return {
      visible: false,
      fileUploadList: [],
      timer: null,
      tableLoading: false
    }
  },
  props: {
    importUploader: Object
  },
  components: {
    ProgressBar
  },
  mounted() {
    if (this.isChecked('Data.Migration.Import.List')) {
      this.importUploader.on('startUploadFile', this.onStartUploadFile)
    }
  },
  beforeDestroy() {
    this.destroyInterval()

    if (this.isChecked('Data.Migration.Import.List')) {
      this.importUploader.off('startUploadFile', this.onStartUploadFile)
    }
  },
  methods: {
    onStartUploadFile() {
      this.visible = true

      this.tableLoading = true
      this.queryFilesUpload().then(() => {
        this.tableLoading = false
        if (!this.timer) {
          this.timer = setInterval(this.refreshFileList, 1000)
        }
      })
    },
    refreshUploadList() {
      this.tableLoading = true
      this.queryFilesUpload().then(() => {
        this.tableLoading = false
        if (!this.timer) {
          this.timer = setInterval(this.refreshFileList, 1000)
        }
      })
    },
    uploadControl(fileInfo) {
      let find = Store.uploaders.find(
        el => el.schemeType === fileInfo.schemeType
      )

      let uploader = find.uploader
      let fileStatus = fileInfo.status
      if (fileStatus === 1) {
        uploader.fire('pauseFileUpload', { fileInfo })
      }
      if (fileStatus === 2) {
        uploader.setImportType(fileInfo.importType)
        uploader.setCurrFileInfo(fileInfo)

        let pausedFiles = uploader.pausedFiles
        let findPauseFile = pausedFiles.find(
          el => el.fileDataId === fileInfo.fileDataId
        )
        if (findPauseFile) {
          uploader.setStatus('continue')
          uploader.fire('continueFileUpload', { fileInfo })
        } else {
          uploader.setStatus('reContinue')
        }
      }
    },
    deleteFileById(fileInfo) {
      if (fileInfo.status < 0) {
        let find = Store.uploaders.find(
          el => el.schemeType === fileInfo.schemeType
        )
        if (find) {
          let uploader = find.uploader
          let findIndex = uploader.uploadFiles.findIndex(
            el =>
              this.isSameFile(el, fileInfo) &&
              el.dataSetId === fileInfo.dataSetId
          )
          if (findIndex !== -1) {
            uploader.uploadFiles.splice(findIndex, 1)
          }
        }
        return
      }

      let fileDataId = fileInfo.id
      deleteFileService(fileDataId).then(response => {
        if (response.isSuccess) {
          this.$message.success('删除成功')
          this.refreshUploadList()
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    destroyInterval() {
      this.timer && clearInterval(this.timer)
      this.timer = null
    },
    refreshFileList() {
      this.queryFilesUpload().then(() => {
        let validFiles = this.fileUploadList.filter(
          el => el.status !== 5 && el.status !== 7
        )
        if (!validFiles.length) {
          this.destroyInterval()
        }

        let pauseList = this.fileUploadList.filter(el => el.status === 2)
        if (pauseList.length) {
          this.refreshDom()
        }
      })
    },
    closeDialog() {
      this.destroyInterval()
      this.visible = false
    },
    queryFilesUpload() {
      return new Promise(resolve => {
        let params = {
          resultCount: 1000,
          skipCount: 0,
          name: '',
          status: [0, 1, 2, 5, 6, 7, 8]
        }
        importUploadListService(params).then(response => {
          if (response.isSuccess) {
            let result = response.data
            let fileUploadList = result.items
            fileUploadList = fileUploadList.filter(
              el => el.scheme === 'ImportDoc'
            )
            fileUploadList.forEach(item => {
              let bussinessInfo = item.fileBusinessInfo
                ? item.fileBusinessInfo
                : {}
              item['schemeType'] = item.scheme
              item['importType'] = Number(bussinessInfo.importType)
              item['ownerId'] = bussinessInfo.ProjectOwnerId
              item['projId'] = bussinessInfo.projId
              item['projName'] = bussinessInfo.projName
              item['status'] = item.uploadStatus
              item['length'] = item.size
              item['fileDataId'] = item.id
              if (item.blobIndex || item.blobIndex === 0) {
                let currIndex = item['blobIndex'] + 1
                let rate = Math.floor((currIndex / item.blobCount) * 10000)
                item['rate'] = rate
              }
            })
            let uploaders = Store.uploaders.filter(el =>
              el.schemeType.includes('ImportDoc')
            )
            // 前端的上传文件列表
            let customUploadList = []
            uploaders.forEach(uploader => {
              let uploadFiles = uploader.uploader.uploadFiles
              let uploadingFiles = uploader.uploader.uploadingFiles

              customUploadList = [
                ...uploadingFiles,
                ...uploadFiles,
                ...customUploadList
              ]
            })

            customUploadList.forEach(item => {
              let findIndex = fileUploadList.findIndex(el =>
                this.isSameFile(el, item)
              )
              if (findIndex === -1) {
                fileUploadList.push(item)
              } else {
                let status = fileUploadList[findIndex].status
                // 如果后端接口返回的状态不是上传中，则按前端状态显示
                if (status !== 1) {
                  fileUploadList[findIndex].status = item.status
                }
              }
            })

            this.fileUploadList = fileUploadList
            resolve()
          }
        })
      })
    },
    refreshDom() {
      this.fileUploadList.forEach(item => {
        let find = Store.uploaders.find(el => el.schemeType === item.schemeType)
        if (find) {
          let pausedFiles = find.uploader.pausedFiles
          let findPauseFile = pausedFiles.find(el => el.fileDataId === item.id)
          if (item.status === 2 && !findPauseFile) {
            let continueDom = document.getElementById(`continue-${item.id}`)
            if (continueDom) {
              if (
                !continueDom.children[0] ||
                !continueDom.children[0].className.includes('webuploader-pick')
              ) {
                let uploader = find.uploader
                uploader.uploader.addButton({
                  id: `#continue-${item.id}`,
                  multiple: false
                })
              }
            }
          }
        }
      })
    },
    isSameFile(fileInfo1, fileInfo2) {
      return (
        fileInfo1.fileName === fileInfo2.fileName &&
        fileInfo1.length === fileInfo2.length
      )
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData;
      let find = permissionData.find(
        (el) => el.permissionCode === permissionCode
      );
      return find.isCheck;
    },
    formatFileSize
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.dialog-primary.upload-list-box {
  border: 1px solid var(--dailog-border-color) !important;
}
.upload-list-box {
  position: absolute;
  box-shadow: var(--base-bg-dark-color30);
  bottom: 16px;
  right: 16px;
  z-index: 5;
  border-radius: 16px;
  width: 760px;
  overflow: hidden;

  .header {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    background: var(--dialog-header-bg-color);
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;

    .title {
      color: var(--dialog-header-text-color);
    }

    .close-btn {
      position: absolute;
      top: 8px;
      right: 16px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;

      &:hover {
        background-color: var(--dialog-header-icon-bgColor);
      }

      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--default-color);
        cursor: pointer;

        &:hover {
          background: var(--dialog-header-icon-bgColor);
        }
      }
    }
  }

  .common-table-box {
    height: 360px;

    .wating-text {
      font-size: 15px;
      color: var(--runing-status-color);
      .icon {
        margin-right: 10px;
      }
    }

    .publish-small-table {
      :deep(.el-table__header) {
        .is-center {
          .cell {
            justify-content: center;
          }
        }
      }
    }

    .common-progress-box {
      display: flex;

      .el-progress {
        width: 80%;
      }

      .custom-text {
        width: 60px;
        line-height: 12px;
        font-size: 12px;
        text-align: center;

        .text {
          color: var(--success-status-color);
        }
      }

      &:hover {
        .custom-text {
          display: block;
        }
      }
    }
  }
}
</style>
